import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom'; // Import Link
import "./Login.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mfaToken, setMfaToken] = useState('');
  const [error, setError] = useState('');
  const [isMFARequired, setIsMFARequired] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State to manage password visibility
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate(); // Initialize useNavigate


    const handleSubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      setError('');
      try {
        // Call your backend login endpoint
        const response = await axios.post('http://localhost:3001/login', { email, password });
        console.log('Server Response:', response.data);
      
        // if (response.data.token) {
        //   localStorage.setItem('token', response.data.token);
      
              // Check if the response indicates that MFA is required.
        // For example, if the response message includes "MFA token sent" (adjust based on your backend logic).
        if (
          response.data.message &&
          response.data.message.toLowerCase().includes("mfa token sent")
        ) {
          // Switch to the MFA verification step
          setIsMFARequired(true);
        } else if (response.data.token) {
          // If the backend returns a JWT token directly, save it and redirect based on role
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('role', response.data.role);
          localStorage.setItem('user_id', response.data.user_id); // Store user_id
          redirectBasedOnRole(response.data.role);
        }
 
      } catch (err) {
        console.error('Error during login:', err);
        setError(err.response?.data?.error || 'Login failed. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };

    // Handler for the MFA token submission
    const handleMFASubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      setError('');
      try {
        // Call your MFA verification endpoint.
        // Adjust the endpoint and payload as per your backend implementation.
        const baseUrl = process.env.NODE_ENV !== 'production' 
          ? 'http://localhost:3001'
          : 'https://server.phumulanintulistudio.com';
        // const response = await axios.post(`${baseUrl}/auth/verify-mfa`, { email, token: mfaToken });
        const response = await axios.post(`${baseUrl}/auth/verify-mfa`, { email, token: mfaToken });
        console.log('MFA Verification Response:', response.data);

        // if (response.data.token && response.data.role) {
        //   // Save the token and role in local storage
        //   localStorage.setItem('token', response.data.token);
        //   localStorage.setItem('role', response.data.role);
        //   localStorage.setItem('user_id', response.data.user_id); // Store user_id
        //  // navigate('/dashboard/admin'); // Or use a role-based redirection similar to the login handler
        //  // Redirect based on role
        //  redirectBasedOnRole(response.data.role);
        // }

        if (response.data.token && response.data.role) {
          handleLoginSuccess(response.data);
        }

        
  
        
      } catch (err) {
        console.error('Error during MFA verification:', err);
        setError(err.response?.data?.error || 'MFA verification failed. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };

    const handleLoginSuccess = (data) => {
      localStorage.setItem('token', data.token);
      localStorage.setItem('role', data.role);
      localStorage.setItem('user_id', data.user_id);
      localStorage.setItem('userData', JSON.stringify(data)); // Store user data
      redirectBasedOnRole(data.role);
    };

    const redirectBasedOnRole = (role) => {
      switch (role) {
        case 'admin':
          navigate('/dashboard/admin');
          break;
        case 'artist':
          navigate('/dashboard/artist/dashboard');
          break;
        case 'collector':
          navigate('/dashboard/customer');
          break;
        case 'team':
          navigate('/dashboard/team');
          break;
        case 'publisher':
          navigate('/dashboard/collaborator');
          break;
        case 'collaborator':
          navigate('/dashboard/collaborator');
          break;
        default:
          navigate('/dashboard/user');
      }
    };

    // Function to toggle password visibility
    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword); // Toggle password visibility
    };
  
  return (
    <div className="login">
      <div className="loginContainer">
        {/* If MFA is not yet required, show the login form */}
        {!isMFARequired ? (
          <form onSubmit={handleSubmit}>
            <label>
              Email:
              <input
                className="email"
                placeholder="Enter your email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </label>

            <label>
              Password:
              <div style={{ position: "relative", }}>
              <input
                placeholder="Enter your password"
                // type="password"
                type={showPassword ? "text" : "password"} // Toggle input type
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  style={{
                    position: "absolute",
                    float: "right",
                    // right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>              
              </div>

            </label>


            {error && <p className="error">{error}</p>}
            <button 
            className="login-button" type="submit" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
            </button>
            <p>
              Don't have an account? <Link to="/register">Register here</Link>
            </p>
            <p>
              <Link to="/forgot-password">Reset Password</Link>
            </p>
          </form>
        ) : (
          // If MFA is required, show the MFA token form
          <form onSubmit={handleMFASubmit}>
            <p>A MFA token has been sent to your email. Please enter it below.</p>
            <label>
              MFA Token:
              <input
                placeholder="Enter MFA token"
                type="text"
                value={mfaToken}
                onChange={(e) => setMfaToken(e.target.value)}
                required
              />
            </label>
            {error && <p className="error">{error}</p>}
            <button className="login-button" type="submit" disabled={isLoading}>
            {isLoading ? 'Verifying...' : 'Verify MFA'}

            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default Login;
